import { render, staticRenderFns } from "./Wp_image_splice.vue?vue&type=template&id=336934a7&scoped=true&"
import script from "./Wp_image_splice.vue?vue&type=script&lang=js&"
export * from "./Wp_image_splice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336934a7",
  null
  
)

export default component.exports